module.exports = __webpack_public_path__ + "static/media/cezep_payrollTicket_pattern_50.6b9ff20b.jpg";